<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full-middle"
      class="supplier-quoted-history"
  >
    <template #header>报价历史</template>
    <template #content>
      <el-row class="mgb">
        <el-col :span="12">
          <span class="label">产品名称</span>
          <span class="value">{{item.productName}}</span>
        </el-col>
        <el-col :span="12">
          <span class="label">SKU</span>
          <span class="value">{{item.sku}}</span>
        </el-col>
      </el-row>
      <el-row class="mgb">
        <el-col :span="12">
          <span class="label">采购交期(天)</span>
          <span class="value">{{item.purchaseDeliveryDays}}</span>
        </el-col>
        <el-col :span="12">
          <span class="label">最小起订量</span>
          <span class="value">{{item.moq}}</span>
        </el-col>
      </el-row>
      <div class="mgb">
        <span class="label">采购网址</span>
        <span class="value">{{item.purchaseUrl}}</span>
      </div>
      <div>
        <gj-table
            :data="tableData"
            :columns="columns"
            :index="false"
            :show-overflow="false"
            :min-height="400"
            :loading="loading"
        >
          <template v-slot:op="{row}">
            <gj-button type="text" @click="deleteQuoted(row.id)">删除</gj-button>
          </template>
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, responseMixin} from "@/minxins";
  import {deleteQuotedHistory, quotedHistory} from "@/api/purchase";

  export default {
    name: "supplier-detail-quoted-history",
    mixins: [modalMixIn, responseMixin],
    props: {
      item: null,
      code: null,
      mountTo: {
        required: true
      }
    },
    created() {
      this.queryQuoted();
    },
    data() {
      return {
        loading: true,
        columns: [
          {id: 'currency', header: '币种', field: 'currency', minWidth: '100px'},
          {id: 'excludeTaxPrice', header: '不含税单价', field: 'excludeTaxPrice', minWidth: '100px'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', minWidth: '100px'},
          {id: 'invoiceTaxRate', header: '票面税率', field: 'invoiceTaxRate', minWidth: '100px'},
          {id: 'actualTaxRate', header: '实际税率', field: 'actualTaxRate', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '130px'},
          {id: 'productInfo0', header: '操作', field: 'slot:op', minWidth: '100px'},
        ],
        tableData: [],
      }
    },
    methods: {
      deleteQuoted(id) {
        const modal = this.$gjCreate('gj-info-modal', {
          mountTo: this.mountTo,
          props: {
            title: '删除确认',
            content: `是否确定删除报价历史？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteQuotedHistory([id])
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.queryQuoted();
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      queryQuoted() {
        quotedHistory(this.code, this.item.sku)
          .then((data) => {
            this.tableData = data;
          }).complete(() => this.loading = false)
      }
    }
  }
</script>

<style scoped>
  .supplier-quoted-history {}
  .supplier-quoted-history /deep/ .gj-modal--full-middle .el-dialog {
    width: 800px !important;
  }
  .label {
    color: #666;
    display: inline-block;
    width: 100px;
    text-align: right;
    padding-right: 10px;
  }

  .value {
    color: #333;
  }

  .mgb {
    margin-bottom: 10px;
  }
</style>
